import BudgetSection from "../Common/BudgetSection";
import { COLORS } from "../../../lib/appColors";

export default function Income() {
  return (
    <BudgetSection
      itemType="income"
      accentColor={COLORS.income}
      addLabel="ADD INCOME"
      addPath="/budget/income/new"
      emptyMessage='No income records yet. Click "Add Income" to create your first entry.'
    />
  );
}
